/* JCPets cart drawer AB — requires window.JcCartShippingTrustAbConfig from Liquid */

(function () {
    if (window.__cartShippingTrustAbInit) return;
    window.__cartShippingTrustAbInit = true;

    var ATTR = 'data-cart-shipping-trust-ab';
    var MARK = 'data-cart-shipping-trust-ab-badges';
    var injecting = false;
    var OPT_OUT_KEY = 'jc-insurance-opt-out';
    var ensuringInsurance = false;
    var lastEnabled = null;
    var variantActivateTimer = null;
    var JC_INSURANCE_VARIANT_ID = (window.JcCartShippingTrustAbConfig && window.JcCartShippingTrustAbConfig.insuranceVariantId) || null;

    function isDevVariantB() {
      try {
        return new URLSearchParams(window.location.search).get('cart_shipping_trust_ab') === 'b';
      } catch (e) {
        return false;
      }
    }

    function isDevVariantA() {
      try {
        return new URLSearchParams(window.location.search).get('cart_shipping_trust_ab') === 'a';
      } catch (e) {
        return false;
      }
    }

    function isTruthyAbValue(value) {
      if (value == null) return false;
      var normalized = String(value).trim().toLowerCase();
      return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on' || normalized === 'b';
    }

    var BODY_CLASS = 'jc-cart-drawer-ab-on';

    /**
     * IntelliGems owns data-cart-shipping-trust-ab.
     * We ONLY mirror that into a CSS class — never write the attribute back.
     * Writing the watched attribute inside a MutationObserver callback caused a
     * site-wide infinite loop / freeze on the live theme.
     */
    function readAbEnabled() {
      if (!document.body) return false;
      // Preview overrides: ?cart_shipping_trust_ab=a|b
      if (isDevVariantA()) return false;
      if (isDevVariantB()) return true;
      return isTruthyAbValue(document.body.getAttribute(ATTR)) ||
        isTruthyAbValue(document.documentElement.getAttribute(ATTR)) ||
        document.body.classList.contains(BODY_CLASS) ||
        document.documentElement.classList.contains(BODY_CLASS);
    }

    function mirrorAbClass(enabled) {
      if (!document.body) return;
      document.body.classList.toggle(BODY_CLASS, !!enabled);
      document.documentElement.classList.toggle(BODY_CLASS, !!enabled);
    }

    function isEnabled() {
      var enabled = readAbEnabled();
      mirrorAbClass(enabled);
      return enabled;
    }

    function applyPreviewParam() {
      if (!document.body) return;
      if (isDevVariantA()) {
        mirrorAbClass(false);
        return;
      }
      if (isDevVariantB()) {
        // Class-only: enough for CSS (body.jc-cart-drawer-ab-on). Do not setAttribute.
        mirrorAbClass(true);
      }
    }

    function resetUpsellSliders() {
      document.querySelectorAll('[data-cart-upsell-slider]').forEach(function (root) {
        root._upsellSliderInit = false;
        root._upsellGoTo = null;
        var track = root.querySelector('[data-upsell-track]');
        var viewport = root.querySelector('.cart-upsell-slider__viewport');
        root.classList.remove('cart-upsell-slider--scrollable');
        if (track) track.style.transform = '';
        if (viewport) viewport.style.height = '';
        root.querySelectorAll('.cart-upsell-slider__item').forEach(function (item) {
          item.style.flex = '';
          item.style.width = '';
          item.style.maxWidth = '';
        });
      });
    }

    function refreshCartDrawerSections() {
      var sections = getCartSections();
      return fetch(window.location.pathname + '?sections=' + sections.join(','), {
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          applyCartSections(data);
        })
        .catch(function () {
          ensureBadges();
          refreshUpsellSliders();
        });
    }

    function forceDrawerLayoutRefresh() {
      var notification = document.querySelector('cart-notification');
      var drawer = document.getElementById('cart-notification');
      if (!notification || !drawer) return;
      // Clear control-layout inline leftovers and force style recalc for drawer CSS.
      drawer.style.removeProperty('transform');
      drawer.style.removeProperty('top');
      drawer.style.removeProperty('max-height');
      drawer.style.removeProperty('display');
      void document.body.offsetHeight;
      void drawer.offsetHeight;
      if (notification.classList.contains('active') || drawer.classList.contains('active')) {
        drawer.classList.add('active');
        notification.classList.add('active');
      }
    }

    function activateVariant(force) {
      var enabled = isEnabled();
      if (!force && lastEnabled === enabled) return;
      var wasEnabled = lastEnabled;
      lastEnabled = enabled;

      ensureBadges();

      if (enabled) {
        resetUpsellSliders();
        refreshUpsellSliders();
        scheduleEnsureInsurance();
        forceDrawerLayoutRefresh();
        // Re-measure after paint (drawer may have been display:none under control).
        window.requestAnimationFrame(function () {
          refreshUpsellSliders();
          forceDrawerLayoutRefresh();
        });
        // Section refresh when flipping control → variant (or first detect as true).
        if (force || wasEnabled === false || wasEnabled === null) {
          if (variantActivateTimer) clearTimeout(variantActivateTimer);
          variantActivateTimer = setTimeout(function () {
            refreshCartDrawerSections().finally(function () {
              scheduleEnsureInsurance();
              refreshUpsellSliders();
              forceDrawerLayoutRefresh();
            });
          }, 0);
        }
      } else {
        refreshUpsellSliders();
      }
    }

    function getTemplate() {
      return document.querySelector('[' + MARK + ']');
    }

    function insertAfter(reference, node) {
      if (!reference || !reference.parentNode) return;
      if (reference.nextSibling) reference.parentNode.insertBefore(node, reference.nextSibling);
      else reference.parentNode.appendChild(node);
    }

    function hideOriginalUsps() {
      var selectors = [
        '.cart__usps',
        '#main-cart-sidebar .usp__list',
        '.cart-original-usps',
        '.selluxe-guarantees-slider'
      ];
      var enabled = isEnabled();
      selectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (el) {
          if (!el || el.hasAttribute('data-cart-shipping-trust-ab-badges')) return;
          if (enabled) {
            el.style.setProperty('display', 'none', 'important');
            el.setAttribute('hidden', '');
          } else {
            el.style.removeProperty('display');
            el.removeAttribute('hidden');
          }
        });
      });
    }

    function ensureBadges() {
      if (injecting) return;
      injecting = true;
      try {
        hideOriginalUsps();
        var template = getTemplate();
        if (!template) return;

        var anchors = [];
        var drawerCheckout = document.querySelector('#cart-notification-links form[action*="cart"]');
        if (drawerCheckout) anchors.push(drawerCheckout);

        var pageCheckout = document.querySelector('#main-cart-sidebar .cart__ctas');
        if (pageCheckout) anchors.push(pageCheckout);

        anchors.forEach(function (anchor) {
          var parent = anchor.parentNode;
          if (!parent) return;
          if (parent.querySelector('[' + MARK + ']')) return;
          insertAfter(anchor, template.cloneNode(true));
        });
      } finally {
        injecting = false;
      }
    }

    function getUpsellPerView() {
      return 1;
    }

    function initUpsellSlider(root) {
      if (!root || root._upsellSliderInit) return;
      var track = root.querySelector('[data-upsell-track]');
      var items = Array.prototype.slice.call(root.querySelectorAll('.cart-upsell-slider__item')).filter(function (item) {
        return window.getComputedStyle(item).display !== 'none';
      });
      var prev = root.querySelector('[data-upsell-prev]');
      var next = root.querySelector('[data-upsell-next]');
      var pager = root.querySelector('[data-upsell-pager]');
      var viewport = root.querySelector('.cart-upsell-slider__viewport');
      if (!track || !viewport || !items.length) return;

      root._upsellSliderInit = true;
      var page = 0;

      function maxPage(perView) {
        return Math.max(0, Math.ceil(items.length / perView) - 1);
      }

      function updatePager(perView) {
        if (!pager) return;
        var total = maxPage(perView) + 1;
        pager.textContent = (page + 1) + '/' + total;
      }

      function goTo(nextPage) {
        var perView = getUpsellPerView();
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || parseFloat(window.getComputedStyle(track).gap) || 10;
        var canSlide = items.length > perView;
        root.classList.toggle('cart-upsell-slider--scrollable', canSlide);
        viewport.style.height = '';

        if (!canSlide) {
          page = 0;
          items.forEach(function (item) {
            item.style.flex = '';
            item.style.width = '';
            item.style.maxWidth = '';
          });
          track.style.transform = '';
          if (prev) prev.disabled = true;
          if (next) next.disabled = true;
          updatePager(perView);
          return;
        }

        var width = viewport.clientWidth * 0.86;
        items.forEach(function (item) {
          item.style.flex = '0 0 ' + width + 'px';
          item.style.width = width + 'px';
          item.style.maxWidth = width + 'px';
        });

        if (typeof nextPage !== 'number' || isNaN(nextPage)) nextPage = page;
        page = Math.max(0, Math.min(maxPage(perView), nextPage));
        track.style.transform = 'translateX(-' + (page * (width + gap)) + 'px)';
        if (prev) prev.disabled = page === 0;
        if (next) next.disabled = page >= maxPage(perView);
        updatePager(perView);
      }

      if (prev) {
        prev.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(page - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(page + 1);
        });
      }

      root._upsellGoTo = goTo;
      window.requestAnimationFrame(function () { goTo(0); });
    }

    function refreshUpsellSliders() {
      document.querySelectorAll('[data-cart-upsell-slider]').forEach(function (root) {
        if (isEnabled()) {
          initUpsellSlider(root);
          if (root._upsellGoTo) root._upsellGoTo();
        } else {
          var track = root.querySelector('[data-upsell-track]');
          var viewport = root.querySelector('.cart-upsell-slider__viewport');
          root.classList.remove('cart-upsell-slider--scrollable');
          if (track) track.style.transform = '';
          if (viewport) viewport.style.height = '';
          root.querySelectorAll('.cart-upsell-slider__item').forEach(function (item) {
            item.style.flex = '';
            item.style.width = '';
            item.style.maxWidth = '';
          });
        }
      });
    }

    function getCartSections() {
      var cartNotification = document.querySelector('cart-notification');
      if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
        return cartNotification.getSectionsToRender().map(function (section) { return section.id; });
      }
      return ['cart-notification-products', 'cart-notification-links', 'cart-icon-bubble'];
    }

    function applyCartSections(sections) {
      if (!sections) return;
      getCartSections().forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || !sections[id]) return;
        var html = new DOMParser().parseFromString(sections[id], 'text/html');
        var next = html.querySelector('.shopify-section') || html.body;
        if (next) el.innerHTML = next.innerHTML;
      });
      if (typeof window.syncCartNotificationLinksEmpty === 'function') {
        window.syncCartNotificationLinksEmpty();
      }
      ensureBadges();
      refreshUpsellSliders();
    }

    function getInsuranceVariantId() {
      if (JC_INSURANCE_VARIANT_ID) return String(JC_INSURANCE_VARIANT_ID);
      var root = document.querySelector('[data-cart-shipping-insurance]');
      return root ? root.getAttribute('data-variant-id') : null;
    }

    function isInsuranceVariantId(value) {
      var id = getInsuranceVariantId();
      return id != null && String(value) === id;
    }

    function isInsuranceOptOut() {
      try {
        return sessionStorage.getItem(OPT_OUT_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    function setInsuranceOptOut(optedOut) {
      try {
        if (optedOut) sessionStorage.setItem(OPT_OUT_KEY, '1');
        else sessionStorage.removeItem(OPT_OUT_KEY);
      } catch (e) {
        /* ignore */
      }
    }

    function isCartMutateUrl(url) {
      return (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1
      );
    }

    function scheduleEnsureInsurance() {
      if (!isEnabled()) return;
      [50, 350, 900].forEach(function (ms) {
        setTimeout(ensureInsuranceInCart, ms);
      });
    }

    function ensureInsuranceInCart() {
      if (!isEnabled() || ensuringInsurance || window.__jcInsuranceMutating) return;
      var variantId = getInsuranceVariantId();
      if (!variantId) return;

      ensuringInsurance = true;
      fetch((window.routes && routes.cart_url) || '/cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var insuranceItem = null;
          var paidQty = 0;
          (cart.items || []).forEach(function (item) {
            if (isInsuranceVariantId(item.variant_id)) insuranceItem = item;
            else paidQty += item.quantity || 0;
          });

          if (!cart.item_count || paidQty === 0) {
            if (!cart.item_count) setInsuranceOptOut(false);
            ensuringInsurance = false;
            return;
          }

          if (insuranceItem && insuranceItem.quantity > 1) {
            return fixInsuranceQuantity(insuranceItem);
          }

          if (!insuranceItem && !isInsuranceOptOut()) {
            return addInsuranceAuto();
          }

          ensuringInsurance = false;
        })
        .catch(function () {
          ensuringInsurance = false;
        });
    }

    function fixInsuranceQuantity(insuranceItem) {
      var sections = getCartSections();
      var body = JSON.stringify({
        id: insuranceItem.key,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      });
      window.__jcInsuranceMutating = true;
      return fetch((window.routes && routes.cart_change_url) || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data.status) applyCartSections(data.sections);
        })
        .finally(function () {
          window.__jcInsuranceMutating = false;
          ensuringInsurance = false;
        });
    }

    function addInsuranceAuto() {
      var variantId = getInsuranceVariantId();
      if (!variantId) {
        ensuringInsurance = false;
        return Promise.resolve();
      }

      var sections = getCartSections();
      var body = JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      });

      window.__jcInsuranceMutating = true;
      return fetch((window.routes && routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Insurance auto-add failed');
          applyCartSections(data.sections);
        })
        .catch(function () {
          /* silent — user can toggle manually */
        })
        .finally(function () {
          window.__jcInsuranceMutating = false;
          ensuringInsurance = false;
        });
    }

    function installAutoInsuranceHook() {
      if (window.__jcAutoInsuranceFetchInstalled) return;
      window.__jcAutoInsuranceFetchInstalled = true;
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        return nativeFetch(input, init).then(function (response) {
          if (isCartMutateUrl(url)) scheduleEnsureInsurance();
          return response;
        });
      };
    }

    function installAutoInsuranceXhrHook() {
      if (window.__jcAutoInsuranceXhrInstalled) return;
      window.__jcAutoInsuranceXhrInstalled = true;
      var nativeOpen = XMLHttpRequest.prototype.open;
      var nativeSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__jcInsuranceUrl = String(url || '');
        this.__jcInsuranceMethod = String(method || 'GET').toUpperCase();
        return nativeOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        var url = this.__jcInsuranceUrl || '';
        if (this.__jcInsuranceMethod === 'POST' && isCartMutateUrl(url)) {
          this.addEventListener('loadend', scheduleEnsureInsurance);
        }
        return nativeSend.apply(this, arguments);
      };
    }

    function setInsuranceLoading(root, loading) {
      if (!root) return;
      root.classList.toggle('is-loading', !!loading);
      var checkbox = root.querySelector('[data-cart-insurance-toggle]');
      if (checkbox) checkbox.disabled = !!loading;
    }

    function toggleInsurance(checkbox) {
      if (!isEnabled() || !checkbox) return;
      var root = checkbox.closest('[data-cart-shipping-insurance]');
      if (!root) return;

      var variantId = root.getAttribute('data-variant-id');
      var lineKey = root.getAttribute('data-line-key');
      var shouldAdd = checkbox.checked;
      var sections = getCartSections();
      var body;

      root.classList.toggle('is-on', shouldAdd);
      setInsuranceLoading(root, true);
      window.__jcInsuranceMutating = true;
      setInsuranceOptOut(!shouldAdd);

      if (shouldAdd) {
        body = JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname
        });
        fetch((window.routes && routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: body
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) throw new Error(data.description || 'Insurance add failed');
            applyCartSections(data.sections);
            var cartNotification = document.querySelector('cart-notification');
            if (cartNotification && !cartNotification.classList.contains('active')) {
              if (typeof cartNotification.open === 'function') cartNotification.open();
            }
          })
          .catch(function () {
            checkbox.checked = false;
            root.classList.remove('is-on');
          })
          .finally(function () {
            window.__jcInsuranceMutating = false;
            setInsuranceLoading(root, false);
          });
        return;
      }

      body = JSON.stringify({
        id: lineKey || Number(variantId),
        quantity: 0,
        sections: sections,
        sections_url: window.location.pathname
      });
      fetch((window.routes && routes.cart_change_url) || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Insurance remove failed');
          applyCartSections(data.sections);
        })
        .catch(function () {
          checkbox.checked = true;
          root.classList.add('is-on');
        })
        .finally(function () {
          window.__jcInsuranceMutating = false;
          setInsuranceLoading(root, false);
        });
    }

    function bindInsuranceEvents() {
      if (window.__cartShippingInsuranceBound) return;
      window.__cartShippingInsuranceBound = true;

      document.addEventListener('change', function (event) {
        var checkbox = event.target.closest('[data-cart-insurance-toggle]');
        if (!checkbox) return;
        toggleInsurance(checkbox);
      });

      document.addEventListener('click', function (event) {
        var openBtn = event.target.closest('[data-cart-insurance-info]');
        if (openBtn) {
          event.preventDefault();
          var root = openBtn.closest('[data-cart-shipping-insurance]');
          var panel = root && root.querySelector('[data-cart-insurance-info-panel]');
          if (panel) panel.hidden = false;
          return;
        }
        var closeBtn = event.target.closest('[data-cart-insurance-info-close]');
        if (closeBtn) {
          event.preventDefault();
          var closeRoot = closeBtn.closest('[data-cart-shipping-insurance]');
          var closePanel = closeRoot && closeRoot.querySelector('[data-cart-insurance-info-panel]');
          if (closePanel) closePanel.hidden = true;
        }
      });
    }

    function init() {
      applyPreviewParam();
      bindInsuranceEvents();
      installAutoInsuranceHook();
      installAutoInsuranceXhrHook();
      activateVariant(true);

      if (!window.__cartUpsellSliderResize) {
        window.__cartUpsellSliderResize = true;
        window.addEventListener('resize', function () {
          document.querySelectorAll('[data-cart-upsell-slider]').forEach(function (root) {
            if (root._upsellGoTo) root._upsellGoTo();
          });
        });
      }

      function observeAbTarget(target) {
        if (!target || target.__jcCartShippingTrustAbObserved) return;
        target.__jcCartShippingTrustAbObserved = true;
        new MutationObserver(function (mutations) {
          var changed = mutations.some(function (mutation) {
            return mutation.attributeName === ATTR;
          });
          if (!changed) return;
          // Read-only reaction: mirror class + refresh UI. Never write ATTR here.
          activateVariant(false);
        }).observe(target, { attributes: true, attributeFilter: [ATTR] });
      }

      observeAbTarget(document.body);
      observeAbTarget(document.documentElement);

      // Late IntelliGems assign: short read-only poll (class mirror only, no setAttribute).
      if (!window.__jcCartShippingTrustAbPoll) {
        window.__jcCartShippingTrustAbPoll = true;
        var polls = 0;
        var pollId = setInterval(function () {
          polls += 1;
          activateVariant(false);
          if (polls >= 40 || lastEnabled === true) {
            clearInterval(pollId);
          }
        }, 250);
      }

      var drawerLinks = document.getElementById('cart-notification-links');
      if (drawerLinks) {
        new MutationObserver(function () {
          if (injecting) return;
          ensureBadges();
          refreshUpsellSliders();
        }).observe(drawerLinks, { childList: true });
      }

      var sidebar = document.getElementById('main-cart-sidebar');
      if (sidebar) {
        new MutationObserver(function () {
          if (injecting) return;
          ensureBadges();
        }).observe(sidebar, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.JcCartShippingTrustAb = {
      isEnabled: isEnabled,
      refresh: function () {
        activateVariant(true);
      }
    };
  })();
